import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { SubscriptionBannerComponent } from './subscription-banner.component';

@NgModule({
  declarations: [SubscriptionBannerComponent],
  imports: [IconModule, RouterModule, CommonModule, ButtonModule],
  exports: [SubscriptionBannerComponent],
})
export class SubscriptionBannerModule {}
export { SubscriptionBannerComponent } from './subscription-banner.component';
